import API from "shared/services/Api";
import { INotes, INotesResponse, ISaveNotes } from "shared/types/Notes";

export const getNotes = async (data: INotes): Promise<INotesResponse> =>
  API.get(`oc/observacoes?id=${data.userId}&paciente_id=${data.paciente_id}`);

export const saveNotes = async (
  userId: string,
  data: ISaveNotes
): Promise<INotesResponse> => API.post(`oc/observacoes?id=${userId}`, data);

export const editNotes = async (
  userId: string,
  isObs: number,
  data: { paciente_id: number; observacao: string }
) => API.put(`oc/observacoes/${isObs}?id=${userId}`, data);

export const excludeNotes = async (userId: string, isObs: number) =>
  API.delete(`oc/observacoes/${isObs}?id=${userId}`);
